import React, { useState } from "react";
import { IntegrationsApi } from "../../api/integrationsApi";

interface Props {
  onClose: () => void;
  onCreated: () => void;
}

export default function IntegrationCreateModal({ onClose, onCreated }: Props) {
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState("");

  const create = async () => {
    await IntegrationsApi.create({
      name,
      displayName,
      enabled: false,
      config: {},
    });

    onCreated();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Новая интеграция</h2>

        <label>Системное имя</label>
        <input value={name} onChange={(e) => setName(e.target.value)} />

        <label>Название</label>
        <input
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
        />

        <div className="modal-actions">
          <button onClick={create}>Создать</button>
          <button onClick={onClose} className="cancel">
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
}
